(function () {
  'use strict';

  const MAX_TARGET_QUANTITY = 10;
  const TARGET_PRODUCT_IDS = new Set(['15418389692548', '15418388283524']);
  const TARGET_VARIANT_IDS = new Set(['67663934390404', '67663893266564']);
  const MESSAGE = '対象商品は2商品合計で10個までご購入いただけます。';
  const originalFetch = window.fetch.bind(window);
  let cartMutationQueue = Promise.resolve();

  function cartPath(input) {
    const value = input instanceof Request ? input.url : input;
    return new URL(typeof value === 'string' ? value : value.url, window.location.origin)
      .pathname.replace(/\/$/, '');
  }

  function isCartMutation(input) {
    return /\/cart\/(add|change|update)(?:\.js)?$/.test(cartPath(input));
  }

  async function requestData(input, init) {
    const body = init && init.body !== undefined
      ? init.body
      : input instanceof Request
        ? await input.clone().text()
        : null;

    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (_) { return Object.fromEntries(new URLSearchParams(body)); }
    }
    if (body instanceof URLSearchParams) return Object.fromEntries(body);
    if (body instanceof FormData) return Object.fromEntries(body);
    return body || {};
  }

  async function getCart() {
    const response = await originalFetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  function isTargetItem(item) {
    return TARGET_PRODUCT_IDS.has(String(item.product_id));
  }

  function currentTargetQuantity(cart) {
    return cart.items.reduce((sum, item) => sum + (isTargetItem(item) ? Number(item.quantity) : 0), 0);
  }

  function findLine(cart, id) {
    const needle = String(id);
    return cart.items.find((item, index) =>
      String(index + 1) === needle || String(item.key) === needle || String(item.variant_id) === needle || String(item.id) === needle
    );
  }

  function proposedQuantity(path, data, cart) {
    const current = currentTargetQuantity(cart);

    if (/\/add(?:\.js)?$/.test(path)) {
      const additions = Array.isArray(data.items) ? data.items : [data];
      return additions.reduce((sum, item) =>
        sum + (TARGET_VARIANT_IDS.has(String(item.id)) ? Number(item.quantity || 1) : 0), current);
    }

    if (/\/change(?:\.js)?$/.test(path)) {
      const line = findLine(cart, data.id || data.line);
      return line && isTargetItem(line)
        ? current - Number(line.quantity) + Number(data.quantity)
        : current;
    }

    if (/\/update(?:\.js)?$/.test(path)) {
      const updates = data.updates || {};
      return cart.items.reduce((sum, item, index) => {
        if (!isTargetItem(item)) return sum;
        const next = updates[item.key] ?? updates[String(item.variant_id)] ?? updates[String(item.id)] ?? updates[String(index + 1)];
        return sum + Number(next === undefined ? item.quantity : next);
      }, 0);
    }

    return current;
  }

  function showError(current) {
    const remaining = Math.max(0, MAX_TARGET_QUANTITY - current);
    const text = `${MESSAGE}（現在 ${current}個、追加可能 ${remaining}個）`;
    let alert = document.getElementById('wake-cart-quantity-limit-error');
    if (!alert) {
      alert = document.createElement('div');
      alert.id = 'wake-cart-quantity-limit-error';
      alert.setAttribute('role', 'alert');
      alert.style.cssText = 'position:fixed;z-index:2147483647;left:50%;bottom:24px;max-width:calc(100% - 32px);transform:translateX(-50%);padding:12px 16px;background:#b42318;color:#fff;border-radius:4px;font-size:14px;line-height:1.5;box-shadow:0 4px 16px rgba(0,0,0,.2)';
      document.body.appendChild(alert);
    }
    alert.textContent = text;
    window.clearTimeout(alert._wakeTimeout);
    alert._wakeTimeout = window.setTimeout(() => alert.remove(), 6000);
    document.dispatchEvent(new CustomEvent('wake:cart-quantity-limit-error', { detail: { current, remaining, message: text } }));
  }

  function blockedResponse(current) {
    showError(current);
    return new Response(JSON.stringify({ status: 422, description: MESSAGE, errors: MESSAGE }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  async function guardMutation(input, init) {
    const path = cartPath(input);
    const data = await requestData(input, init);
    const cart = await getCart();
    const current = currentTargetQuantity(cart);
    const proposed = proposedQuantity(path, data, cart);
    return proposed > MAX_TARGET_QUANTITY
      ? blockedResponse(current)
      : originalFetch(input, init);
  }

  window.fetch = function (input, init) {
    if (!isCartMutation(input)) return originalFetch(input, init);
    const task = cartMutationQueue.then(
      () => guardMutation(input, init),
      () => guardMutation(input, init)
    );
    cartMutationQueue = task.then(() => undefined, () => undefined);
    return task;
  };
})();
